import { HeadersFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { getHeadersFromLoader } from "@portal-frontend-ssr/ssr-utils";
import { articlePageLoader } from "~/shared/loaders/articlePageLoader";
import { getArticlePageMeta } from "~/shared/helpers/metaTags/getArticlePageMeta";
import { ArticlePage } from "~/shared/components/ArticlePage";

export const loader = articlePageLoader;
export const meta = getArticlePageMeta;
export const headers: HeadersFunction = getHeadersFromLoader;

export const Component = () => {
  const { articlePage, latestNews, tournamentTimeline } = useLoaderData<typeof loader>();
  return <ArticlePage page={articlePage} latestNews={latestNews} tournamentTimeline={tournamentTimeline} />;
};

export default Component;
